// Веб-вклад модуля `glossary` — термины.
//
// Плитка воркспейса ведёт себя двойственно (открыть словарь либо запустить
// сборку недостающих терминов) — это поведение клиентского слоя; отсюда
// приходит только состав, знак и место.

import { IconBook2 } from "@tabler/icons-react";
import {
	SECTION_CATEGORY,
	SECTION_ICONS,
	SECTION_TINT,
} from "@/components/navigation/section-icons";
import { belongsToLiveMaterial } from "@/lib/powersync/live-material-sql";
import type { WebModuleManifest } from "./_contract";

export const glossaryWebManifest = {
	id: "glossary",
	icon: SECTION_ICONS.glossary,
	labelKey: "nav.glossary",
	tint: SECTION_TINT.glossary,
	category: SECTION_CATEGORY.glossary,
	routes: ["/glossary"],

	// Баннер объясняет ВЫГОДУ, а не функцию: слово «глоссарий» понятно, а вот
	// зачем он сверх обычного словаря — нет (`docs/copy/ONBOARDING-COPY.md` §8.3).
	intro: {
		titleKey: "glossary:intro.title",
		bodyKey: "glossary:intro.body",
		bulletKeys: [
			"glossary:intro.bullets.0",
			"glossary:intro.bullets.1",
			"glossary:intro.bullets.2",
		],
	},

	nav: [
		{
			key: "glossary",
			to: "/glossary",
			icon: SECTION_ICONS.glossary,
			labelKey: "nav.glossary",
			order: 50,
			// Термин без материала-владельца жив (глобальный словарь), термин
			// удалённого материала — нет.
			// Предикат ОБЩИЙ со списком раздела (`use-glossary-query.ts`).
			badge: {
				kind: "powersync",
				sql: `SELECT count(*) FROM glossary_terms g
					WHERE g.user_id = ? AND g.deleted_at IS NULL AND ${belongsToLiveMaterial("g")}`,
			},
		},
	],

	launch: [
		{
			key: "glossary",
			icon: SECTION_ICONS.glossary,
			tint: SECTION_TINT.glossary,
			titleKey: "launcher.glossary",
			hintKey: "launcher.glossaryHint",
			to: "/glossary",
			order: 110,
		},
	],

	workspaceTools: [
		{
			key: "glossary",
			channel: "read",
			// IconBook2 (раскрытая книга), тогда как эмблема раздела — IconBook.
			// Расхождение унаследовано; сведение знаков — отдельное решение дизайна.
			icon: IconBook2,
			steps: { 1: 20 },
			kitKind: "glossary",
		},
	],
} satisfies WebModuleManifest;
